

import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {ApiAdminSlaHolidaysService} from "../../../../../services/api/admin/admin-sla-holidays-api/admin-sla-holidays-api.service";
import {DialogService} from "../../../../../services/dialog-service/dialog.service";
import {AdminSlaHolidaysComponentDialog} from "./admin-sla-holidays-create-edit-dialog/admin-sla-holidays-create-edit-dialog.component";
import {ModalConfirmationComponent} from "../../../../../shared/modal-confirmation/modal-confirmation.component";

@Component({
  selector: 'app-admin-sla-holidays',
  templateUrl: './admin-sla-holidays.html'
})
export class AdminSlaHolidaysComponent implements OnInit {

  data;
  isLoading = true;

  constructor(private apiAdminSlaHolidaysService: ApiAdminSlaHolidaysService, private dialogService: DialogService, private viewReference: ViewContainerRef) {
    this.getData();
  }

  ngOnInit(): void {
  }

  getData(){
    this.isLoading = true;
    this.apiAdminSlaHolidaysService.listAll().then(response => {
      this.data = response;
      this.isLoading = false;
    }).catch(error => {
      this.isLoading = false;
      if (error.status === 403) {
        window.location.href = '/';  // Redirect to self-service
      } else {
        console.log('Unhandled error:', error);
      }
    });
  }

  create(){
    // Replace null with Component
    this.dialogService.createDialog(AdminSlaHolidaysComponentDialog, null, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  edit(id){
    // Replace null with Component
    this.dialogService.createDialog(AdminSlaHolidaysComponentDialog, id, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  delete(id){
    this.dialogService.createDialog(ModalConfirmationComponent, 'Are you sure?', this.viewReference)
      .then(confirmed => {
        this.apiAdminSlaHolidaysService.delete(id).then(response => this.getData())
      }, cancelled => null)
  }



}
